import {
  policyActions,
  quoteActions,
} from '../constants/registry/quotes-table.constant';
import { DynamicTableConfig } from '../interfaces/dynamic-table.interface';

export const policiesTablePreset: Partial<DynamicTableConfig> = {
  columns: [
    { id: 'title' },
    { id: 'startDate' },
    { id: 'expiryDate' },
    { id: 'status' },
    {
      id: 'contextMenu',
      props: {
        actions: [
          policyActions['viewPolicy'],
          policyActions['viewClient'],
          policyActions['viewDocuments'],
          policyActions['uploadDocuments'],
          policyActions['addContact'],
        ],
      },
    },
  ],
};

export const quotesTablePreset: Partial<DynamicTableConfig> = {
  columns: [
    { id: 'title' },
    { id: 'assignedBroker' },
    { id: 'status' },
    { id: 'lastActivity' },
    {
      id: 'contextMenu',
      props: {
        actions: [
          quoteActions['viewStatus'],
          quoteActions['assignToBroker'],
          quoteActions['viewProposal'],
        ],
      },
    },
  ],
};

export const cancellationsTablePreset: Partial<DynamicTableConfig> = {
  columns: [
    { id: 'title' },
    { id: 'startDate' },
    { id: 'expiryDate' },
    { id: 'requestedCancellationDate' },
  ],
};

export const principalsTablePreset: Partial<DynamicTableConfig> = {
  columns: [
    { id: 'name' },
    { id: 'status' },
    { id: 'qualification' },
    { id: 'id' },
    { id: 'startDate' },
    { id: 'endDate' },
  ],
};
